/* eslint-disable */
import React, {createContext, useContext} from "react"
import {createUseStyles, useTheme} from "react-jss"
import defaultStyle from "../../constants/defaultStyle"
import sheet from "../../styles/globalSheet"

const useGlobalStyle = createUseStyles(sheet)

export const SheetContext = createContext(null)

/**
 * Hook to consume the sheet (global styles) from context.
 * Must be used within a SheetProvider.
 */
export const useSheet = () => {
    const context = useContext(SheetContext)
    if (!context) {
        throw new Error("useSheet must be used within SheetProvider")
    }
    return context.sheet
}

const SheetProvider = ({children}) => {
    // We cheat the rules of hooks for retrocompatibility with all our tests
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const theme =
        process.env.NODE_ENV === "test" || process.env.NODE_ENV === "preproduction" ? defaultStyle : useTheme()

    const globalStyle = useGlobalStyle(theme)
    const sheetValue = {
        sheet: {
            classes: globalStyle,
        },
    }

    return <SheetContext.Provider value={sheetValue}>{children}</SheetContext.Provider>
}

export default SheetProvider
